import {Component, EventEmitter, OnInit, signal} from '@angular/core';
import {User} from '../classes/user.class';
import {Router, RouterLink} from '@angular/router';
import {CordovaService} from '../cordova.service';
import {ConfirmDialogService} from '../services/confirm-dialog-service/confirm-dialog.service';
import {LocalStorage} from '../storage.class';
import {DatePipe, formatDate} from '@angular/common';
import {SortingComponent} from '../sorting.component';
import {Repair} from '../classes/repair.class';
import {RepairService} from '../services/repair.service';
import {debounceTime} from 'rxjs/operators';
import * as XLSX from 'xlsx';
import {Settings} from '../settings.class';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatRipple} from "@angular/material/core";
import {SortingIconComponent} from "../sorting-icon.component";

@Component({
    selector: 'app-repairs',
    templateUrl: './repairs.component.html',
    styleUrls: ['./repairs.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatButton,
        MatSlideToggle,
        FormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatRipple,
        SortingIconComponent,
        DatePipe,
        MatIconButton
    ]
})
export class RepairsComponent extends SortingComponent<Repair> implements OnInit {

    readonly showClosed = signal<boolean>(false);
    readonly user = signal<User>(null);

    searching = new EventEmitter<any>();
    readonly searchText = signal('');
    readonly unfilteredRepairs = signal<Repair[]>([]);

    readonly mayExport = signal<boolean>(false);

    constructor(
        private repairService: RepairService,
        private router: Router,
        private cordovaService: CordovaService,
        private confirmDialog: ConfirmDialogService
    ) {
        super();
    }

    ngOnInit(): void {
        this.mayExport.set(this.AuthorisationService.hasFeature('incidentManagement'));
        this.searching.pipe(debounceTime(125)).subscribe(() => {
            this.list.set(this.unfilteredRepairs().filter(u => {
                const text = `${u?.machine_number?.replace(/[^A-Z0-9]/ig, '')}_${u?.user?.name}_${u?.id}`.toLowerCase();
                return text.indexOf(this.searchText().toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) !== -1;
            }));
        });
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/']);
        });
        this.user.set(LocalStorage.getUser());
        this.getData();
    }

    openIfOne() {
        if (this.list()?.length === 1) {
            this.router.navigate(['repairs', this.list()[0].id]);
        }
    }

    getData() {
        this.repairService.getList(this.showClosed()).then(incidents => {
            this.unfilteredRepairs.set(incidents);
            this.list.set(this.unfilteredRepairs());
            this.currentSort.set('created_at');
            this.desc.set(true);
        });
    }

    delete(event, repair: Repair) {
        event.stopPropagation();
        this.confirmDialog.confirm(
            'Verwijderen',
            `Weet u zeker dat u deze reparatie aangemaakt op ${formatDate(repair.created_at, 'd MMM yyyy, H:mm', 'nl')} wilt verwijderen?`,
            'Verwijderen',
            'Behouden'
        ).then(() => {
            this.repairService.delete(repair.id).then(() => {
                const index = this.list().indexOf(repair);
                this.unfilteredRepairs().splice(index, 1);
                this.list().splice(index, 1);
            });
        }, () => {

        });
    }

    export() {
        const sheetArray = [];
        this.list().forEach(repair => {
            sheetArray.push({
                Melding: repair.id,
                'Machine nummer': repair.machine_number,
                Status: repair.status,
                'Aangemaakt door': repair.user?.name,
                Aangemaakt: new Date(repair.created_at),
                Beschrijving: repair.description
            });
        });
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(sheetArray);
        for (let i = 2; i <= sheetArray.length + 1; i++) {
            worksheet[`E${i}`].z = 'd mmmm yy h:mm';
        }
        worksheet['!cols'] = [
            {width: 8},
            {width: 24},
            {width: 15},
            {width: 30},
            {width: 20},
            {width: 40}
        ];
        const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
        const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        const filename = `VVR_meldingen_${formatDate(new Date(), 'yyyy-MMM-d_H-mm-ss', 'nl')}`;
        Settings.saveAsExcelFile(excelBuffer, filename.replace('.', ''));
    }
}
